module.exports = __webpack_public_path__ + "static/media/75.b081c93f.jpg";